function isIOS() {
return (
/iPad|iPhone|iPod|iPad Simulator|iPhone Simulator|iPod Simulator/.test(
navigator.platform
) ||
(navigator.platform === "MacIntel" &&
navigator.maxTouchPoints > 1)
);
}
class DeferredMedia extends HTMLElement {
constructor() {
super();
const poster = this.querySelector('[id^="Deferred-Poster-"]');
if (!poster) return;
poster.addEventListener("click", this.loadContent.bind(this));
}
loadContent(focus = true) {
if (!this.getAttribute("loaded")) {
const content = document.createElement("div");
content.appendChild(
this.querySelector(
"template"
).content.firstElementChild.cloneNode(true)
);
this.setAttribute("loaded", true);
const deferredElement = this.appendChild(
content.querySelector("video, model-viewer, iframe")
);
if (isIOS()) {
deferredElement.controls = true;
}
deferredElement.play && deferredElement.play();
if (focus) deferredElement.focus();
}
}
}
customElements.define("deferred-media", DeferredMedia);
class ThemeDropdown extends HTMLElement {
constructor() {
super();
this.button = this.querySelector('.dropdown-button');
this.content = this.querySelector('.dropdown-content');
this.direction = this.dataset.direction || 'down';
this.closeOnClick = this.dataset.closeOnClick !== 'false';
this.closeOnOutsideClick = this.dataset.closeOnOutsideClick !== 'false';
this.closeOnEscape = this.dataset.closeOnEscape !== 'false';
this.toggle = this.toggle.bind(this);
this.handleContentClick = this.handleContentClick.bind(this);
this.handleOutsideClick = this.handleOutsideClick.bind(this);
this.handleKeydown = this.handleKeydown.bind(this);
const activeItem = this.querySelector('li.is-active');
if (activeItem && this.button) {
const buttonSpan = this.button.querySelector('span');
if (buttonSpan) buttonSpan.textContent = activeItem.textContent.trim();
}
}
connectedCallback() {
if (this.button && this.content) {
this.button.addEventListener('click', this.toggle);
if (this.closeOnClick) {
this.content.addEventListener('click', this.handleContentClick);
}
if (this.closeOnOutsideClick) {
document.addEventListener('click', this.handleOutsideClick);
}
if (this.closeOnEscape) {
document.addEventListener('keydown', this.handleKeydown);
}
}
}
disconnectedCallback() {
if (this.button) this.button.removeEventListener('click', this.toggle);
if (this.content && this.closeOnClick)
this.content.removeEventListener('click', this.handleContentClick);
if (this.closeOnOutsideClick)
document.removeEventListener('click', this.handleOutsideClick);
if (this.closeOnEscape)
document.removeEventListener('keydown', this.handleKeydown);
}
toggle(event) {
event.stopPropagation();
document.querySelectorAll('theme-dropdown[open], localization-form[open]').forEach(dropdown => {
if (dropdown !== this) dropdown.removeAttribute('open');
});
if (this.hasAttribute('open')) {
this.removeAttribute('open');
} else {
this.setAttribute('open', '');
}
const activeItem = this.querySelector('li.is-active');
if (activeItem && this.button) {
const buttonSpan = this.button.querySelector('span');
if (buttonSpan) buttonSpan.textContent = activeItem.textContent.trim();
}
}
handleContentClick(event) {
this.removeAttribute('open');
}
handleOutsideClick(event) {
if (this.hasAttribute('open') && !this.contains(event.target)) {
this.removeAttribute('open');
}
}
handleKeydown(event) {
if (event.code && event.code.toUpperCase() === 'ESCAPE' && this.hasAttribute('open')) {
this.removeAttribute('open');
}
}
}
customElements.define('theme-dropdown', ThemeDropdown);
class LocalizationForm extends ThemeDropdown {
constructor() {
super();
this.form = this.closest('form');
this.inputName = this.button?.id.includes('language') ? 'language_code' : 'country_code';
this.handleLinkClick = this.handleLinkClick.bind(this);
}
connectedCallback() {
super.connectedCallback();
const links = this.content?.querySelectorAll('a[data-value]') || [];
links.forEach(link => {
link.addEventListener('click', (e) => {
e.preventDefault();
e.stopPropagation();
this.handleLinkClick(link);
});
});
}
handleLinkClick(link) {
const value = link.getAttribute('data-value');
if (!value || !this.form) return;
const input = this.form.querySelector(`input[name="${this.inputName}"]`);
if (!input) return;
input.value = value;
this.querySelectorAll('li').forEach(li => li.classList.remove('is-active'));
link.closest('li')?.classList.add('is-active');
const buttonTextContent = this.button.querySelector('.dropdown-button__text-content');
if (buttonTextContent) {
buttonTextContent.textContent = link.textContent.trim();
}
this.removeAttribute('open');
this.form.submit();
}
}
customElements.define('localization-form', LocalizationForm);
class AccordionDefault extends HTMLElement {
constructor() {
super();
this.hideMultiple = this.hasAttribute("data-hide-multiple");
this.summaryElements = this.querySelectorAll("summary");
this.setInitialAccessibilityAttr();
this.addEventListener("click", e => {
let isBtn = e.target.classList.contains("js-btn");
if (!isBtn) {
isBtn = e.target.closest("summary.js-btn");
}
if (!isBtn) return;
e.preventDefault();
this.toggleDropdown(
e.target.classList.contains("js-btn")
? e.target
: e.target.closest("summary")
);
this.collapseInactiveItems();
});
this.addEventListener("keydown", e => {
const isEscapeKey = e.key === "Escape";
if (!isEscapeKey) {
return;
}
const closestOpenDetails = document.activeElement.closest(
"details.is-active"
);
if (!closestOpenDetails) {
return;
}
const btn = closestOpenDetails.querySelector("summary");
if (this.closest('menu-drawer').classList.contains('facets__drawer')) {
this.closest('menu-drawer').toggleDrawer();
return;
}
this.toggleDropdown(btn);
this.collapseInactiveItems();
});
}
collapseInactiveItems() {
if (!this.hideMultiple) return;
const allSummaryElements = document.querySelectorAll(
"accordion-default summary"
);
allSummaryElements.forEach(summary => {
const accordionDefault = summary.closest("accordion-default");
accordionDefault.toggleDropdown(summary, true);
});
}
toggleDropdown(btn, forceClose) {
const dropdown = btn.nextElementSibling;
const isDropdownTransitioning = dropdown.classList.contains(
"is-transitioning"
);
if (isDropdownTransitioning) {
return;
}
const details = btn.parentElement;
const accordionContainer = details.closest(".product__accordion");
if (forceClose) {
details.classList.remove("is-active");
details.removeAttribute("open");
btn.setAttribute("aria-expanded", false);
dropdown.style.height = "0px";
return;
}
details.classList.toggle("is-active");
const isDetailsActive = details.classList.contains("is-active");
btn.setAttribute("aria-expanded", isDetailsActive);
if (isDetailsActive) {
details.setAttribute("open", "");
dropdown.style.height = `${dropdown.scrollHeight}px`;
setTimeout(() => {
if (accordionContainer) {
const rect = accordionContainer.getBoundingClientRect();
const scrollY = window.scrollY + rect.top - 150;
window.scrollTo({
top: scrollY,
behavior: "smooth"
});
}
}, 150);
} else {
dropdown.style.height = `${dropdown.scrollHeight}px`;
setTimeout(() => {
dropdown.style.height = "0px";
}, 0);
}
dropdown.classList.add("is-transitioning");
dropdown.addEventListener(
"transitionend",
handleHeightTransition
);
function handleHeightTransition(e) {
dropdown.removeEventListener(
"transitionend",
handleHeightTransition
);
dropdown.classList.remove("is-transitioning");
if (isDetailsActive) {
dropdown.style.height = "auto";
return;
}
details.removeAttribute("open");
btn.focus();
}
}
setInitialAccessibilityAttr() {
this.summaryElements.forEach(summaryElement => {
const detailsElement = summaryElement.parentElement;
const dropdown = summaryElement.nextElementSibling;
const isDetailsOpen = detailsElement.hasAttribute("open");
summaryElement.setAttribute("role", "button");
summaryElement.setAttribute("aria-controls", dropdown.id);
summaryElement.setAttribute("aria-expanded", isDetailsOpen);
});
}
}
customElements.define("accordion-default", AccordionDefault);
const nav = document.querySelector(".js-nav");
nav?.addEventListener("click", function (e) {
const isHoverDisabled = matchMedia("(hover: none)").matches;
const isLink = e.target.classList.contains("js-nav-link");
if (!isHoverDisabled || !isLink) {
return;
}
const link = e.target;
const linkItem = link.parentElement;
const linksList = linkItem.parentElement;
const activeLinkItem = linksList.querySelector(
".js-nav-item.is-active"
);
const hasDropdown = linkItem.classList.contains("has-dropdown");
if (activeLinkItem !== linkItem) {
activeLinkItem?.classList.remove("is-active");
}
if (!hasDropdown) {
return;
}
e.preventDefault();
linkItem.classList.toggle("is-active");
});
document.addEventListener("click", function (e) {
const targetActiveLinkItem = e.target.closest(
".js-nav-item.is-active"
);
if (targetActiveLinkItem) {
return;
}
const activeLinkItems = document.querySelectorAll(
".js-nav-item.is-active"
);
if (activeLinkItems.length == 0) {
return;
}
activeLinkItems.forEach(activeLinkItem => {
activeLinkItem.classList.remove("is-active");
});
});
let navItems = document.querySelectorAll(
".js-nav-item.has-dropdown:not(.dropdown)"
);
window.addEventListener("shopify:section:load", function () {
navItems = document.querySelectorAll(
".js-nav-item.has-dropdown:not(.dropdown)"
);
});
["DOMContentLoaded", "resize"].forEach(eventType => {
window.addEventListener(eventType, () => {
navItems = document.querySelectorAll(
".js-nav-item.has-dropdown:not(.dropdown)"
);
navItems.forEach(navItem => {
const dropdown = navItem.querySelector(".js-dropdown");
if (!dropdown) {
return;
}
const { y, height } = navItem.getBoundingClientRect();
const itemTop = y + height;
const dropdownY = dropdown.getBoundingClientRect().y;
const isSameOffset = itemTop === dropdownY;
if (isSameOffset) {
return;
}
const difference = Math.round(dropdownY - itemTop);
navItem.style.setProperty("--after-height", `${difference}px`);
});
});
});
let hero =
document.querySelector(".hero-banner") ||
document.querySelector("main section");
window.addEventListener("shopify:section:load", function () {
hero =
document.querySelector(".hero-banner") ||
document.querySelector("main section");
});
const megaMenu = document.querySelector('nav.js-nav');
if (megaMenu) {
function toggleHeaderTransparency() {
const hasVisibleDropdown = megaMenu.querySelector('.js-dropdown.is-visible');
if (hasVisibleDropdown) {
header.classList.add('is-megamenu-open');
} else {
header.classList.remove('is-megamenu-open');
}
}
megaMenu.querySelectorAll('.js-nav-item').forEach(item => {
const menuContent = item.querySelector('.js-dropdown');
item.addEventListener('mouseenter', () => {
const menuItem = item.getAttribute('data-menu-item');
if (menuItem === null) {
return; 
}
closeAllDropdowns();
if (menuContent) {
menuContent.classList.add('is-visible');
}
toggleHeaderTransparency(); 
});
item.addEventListener('mouseleave', e => {
const related = e.relatedTarget;
if (related && (menuContent?.contains(related) || item.contains(related) || megaMenu.contains(related))) {
return; 
}
closeAllDropdowns();
toggleHeaderTransparency(); 
});
if (menuContent) {
menuContent.addEventListener('mouseleave', e => {
const related = e.relatedTarget;
if (related && (menuContent.contains(related) || item.contains(related) || megaMenu.contains(related))) {
return; 
}
closeAllDropdowns();
toggleHeaderTransparency(); 
});
}
});
megaMenu.addEventListener('mouseleave', () => {
closeAllDropdowns();
toggleHeaderTransparency(); 
});
function closeAllDropdowns() {
megaMenu.querySelectorAll('.js-dropdown.is-visible').forEach(dropdown => {
const item = dropdown.closest('.js-nav-item');
const menuItem = item?.getAttribute('data-menu-item');
const allSublinks = megaMenu.querySelectorAll('.header__nav-sublinks');
allSublinks.forEach((sublink) => {
if (sublink.classList.contains('is-visible')) {
sublink.classList.remove("is-visible");
}
})
if (menuItem === null) {
return; 
}
dropdown.classList.remove('is-visible');
});
}
}
document.querySelectorAll('.header__nav-item.dropdown [data-child-menu-item]').forEach(childItem => {
const childMenuContent = childItem.querySelector('[data-child-menu-content]');
childItem.addEventListener('mouseenter', () => {
document.querySelectorAll('.header__nav-item.dropdown [data-child-menu-content]').forEach(menuContent => {
menuContent.classList.remove('is-visible');
});
childMenuContent?.classList.add('is-visible');
});
childItem.addEventListener('mouseleave', e => {
const related = e.relatedTarget;
if (
related &&
related.closest('[data-child-menu-item]') !== childItem &&
related.closest('[data-child-menu-item]')
) {
childMenuContent?.classList.remove('is-visible');
}
});
});
const animationObserverOptions = {
rootMargin: "-100px"
};
const animationObserver = new IntersectionObserver(entries => {
entries.forEach(entry => {
if (!entry.isIntersecting) {
return;
}
entry.target.classList.add("animation-init");
entry.target.addEventListener(
"animationend",
() => {
entry.target.classList.add("animation-none");
},
{
once: true
}
);
animationObserver.unobserve(entry.target);
});
}, animationObserverOptions);
observeAnimationElements();
window.addEventListener("shopify:section:load", () => {
observeAnimationElements();
});
function observeAnimationElements() {
const animationElements = document.querySelectorAll(
'[class*="js-animation-"]'
);
animationElements.forEach(animationElement => {
animationObserver.observe(animationElement);
});
}
function preventDefault(event) {
event.preventDefault();
}
class DropdownInput extends HTMLElement {
constructor() {
super();
this.select = this.querySelector("select");
this.dropdown = null;
this.buttons = null;
this.detailsTemplate = this.querySelector(
'template[data-name="details"]'
);
this.optionTemplate = this.querySelector(
'template[data-name="option"]'
);
if (!this.select) return;
}
connectedCallback() {
this.init();
}
init() {
this.select.classList.add("hidden");
this.appendTemplate();
}
appendTemplate() {
const detailsTemplate =
this.detailsTemplate.content.firstElementChild.cloneNode(true);
const optionTemplate = this.optionTemplate.content;
const options = Array.from(this.select.options);
if (options.length === 0) return;
const selectedOption = options.find(option => option.selected);
detailsTemplate.querySelector("[data-label]").textContent =
selectedOption.label;
options.forEach(option => {
const html = optionTemplate.cloneNode(true);
const button = html.querySelector("button");
const li = html.querySelector("li");
button.setAttribute("data-value", option.value);
button.textContent = option.label;
button.toggleAttribute("disabled", option.disabled);
li.classList.toggle("is-active", option.selected);
detailsTemplate.querySelector("[data-options]").append(html);
});
this.append(detailsTemplate);
this.dropdown = this.querySelector("details");
this.buttons = this.dropdown.querySelectorAll("button");
this.setHandlers();
}
update() {
this.dropdown = null;
this.buttons = null;
this.querySelector("details")?.remove();
this.appendTemplate();
}
setHandlers() {
this.querySelector("summary").addEventListener(
"click",
this.onSummaryClick.bind(this)
);
this.buttons.forEach((button, index) => {
button.addEventListener("click", event =>
this.onOptionSelect(event, index)
);
});
}
onOptionSelect(event, index) {
event.preventDefault();
Array.from(this.select.options).forEach(option =>
option.removeAttribute("selected")
);
this.select.options[index].setAttribute("selected", "selected");
this.select.value = event.target.dataset.value;
this.select.dispatchEvent(new Event("change", { bubbles: true }));
this.querySelector("[data-label]").textContent =
this.select.options[index].label;
this.setSelectedOption(event.target);
this.update();
}
setSelectedOption(buttonOption) {
const buttonEl = buttonOption;
this.buttons.forEach(button => {
button.parentElement.classList.remove("is-active");
});
buttonEl.parentElement.classList.add("is-active");
this.select.dispatchEvent(new Event("change"));
this.select.closest("form")?.dispatchEvent(new Event("input"));
this.close(
undefined,
this.dropdown.querySelector("summary"),
this.dropdown
);
}
onSummaryClick(event) {
const summaryElement = event.currentTarget;
const detailsElement = summaryElement.parentNode;
const isOpen = detailsElement.hasAttribute("open");
isOpen
? this.close(event, summaryElement, detailsElement)
: this.open(summaryElement, detailsElement);
}
open(summaryElement, detailsElement) {
setTimeout(() => {
detailsElement.classList.add("is-open");
});
summaryElement.setAttribute("aria-expanded", true);
trapFocus(detailsElement, summaryElement);
}
close(event, summaryElement, detailsElement) {
if (event) {
event.preventDefault();
}
detailsElement.classList.remove("is-open");
removeTrapFocus(summaryElement);
this.closeAnimation(detailsElement);
}
closeAnimation(detailsElement) {
let animationStart;
const handleAnimation = time => {
if (animationStart === undefined) {
animationStart = time;
}
const elapsedTime = time - animationStart;
elapsedTime < 300 
? window.requestAnimationFrame(handleAnimation)
: detailsElement.removeAttribute("open");
};
window.requestAnimationFrame(handleAnimation);
}
}
customElements.define("dropdown-input", DropdownInput);
class CountdownTimer extends HTMLElement {
constructor() {
super();
const timezone = this.dataset.timezone,
date = this.dataset.date.split("-").filter(function (el) {
return el != "";
}),
day = parseInt(date[0]),
month = parseInt(date[1]),
year = parseInt(date[2]);
let time = this.dataset.time,
tarhour = 0,
tarmin = 0;
if (time != null) {
time = time.split(":");
tarhour = parseInt(time[0]);
tarmin = parseInt(time[1]);
}
const date_string =
month +
"/" +
day +
"/" +
year +
" " +
(tarhour < 10 ? "0" + tarhour : tarhour) +
":" +
(tarmin < 10 ? "0" + tarmin : tarmin) +
" GMT" +
timezone;
this.countDownDate = new Date(date_string).getTime();
this.timerInterval = null;
this.lastDays = -1;
this.lastHours = -1;
this.lastMinutes = -1;
}
connectedCallback() {
this.startTimer();
}
disconnectedCallback() {
this.stopTimer();
}
startTimer() {
this.updateTime(true);
this.timerInterval = setInterval(() => {
this.updateTime(false);
}, 1000);
}
stopTimer() {
if (this.timerInterval) {
clearInterval(this.timerInterval);
this.timerInterval = null;
}
}
updateTime(initialUpdate = false) {
const _this = this;
const timer_layout = _this.dataset.timerLayout;
const now = new Date().getTime();
let distance = _this.countDownDate - now;
const days = Math.floor(distance / (1000 * 60 * 60 * 24));
const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
const seconds = Math.floor((distance % (1000 * 60)) / 1000);
let daysBlock = _this.querySelector(".days .countdown-timer__column-number");
let hoursBlock = _this.querySelector(".hours .countdown-timer__column-number");
let minutesBlock = _this.querySelector(".minutes .countdown-timer__column-number");
let secondsBlock = _this.querySelector(".seconds .countdown-timer__column-number");
let countdownTimerColumns = _this.querySelector(".countdown-timer__columns");
let countdownTimerMessage = _this.querySelector(".countdown-timer__message");
if (distance < 0) {
_this.stopTimer();
if (daysBlock) daysBlock.innerHTML = 0;
if (hoursBlock) hoursBlock.innerHTML = 0;
if (minutesBlock) minutesBlock.innerHTML = 0;
if (secondsBlock) secondsBlock.innerHTML = 0;
_this.classList.add("loading-effect");
_this.setAttribute("data-is-ended", "true");
if (timer_layout !== "1") {
if (countdownTimerColumns) countdownTimerColumns.classList.add("hidden");
if (countdownTimerMessage) countdownTimerMessage.classList.remove("hidden");
}
if (timer_layout === "1") {
let calloutBannerContentHeading = _this.closest(".callout-banner")?.querySelector(".callout-banner__content-heading");
if (calloutBannerContentHeading) calloutBannerContentHeading.innerHTML = _this.dataset.endMessage;
}
} else {
if (secondsBlock) secondsBlock.innerHTML = CountdownTimer.addZero(seconds);
if (initialUpdate || this.lastMinutes !== minutes) {
if (minutesBlock) minutesBlock.innerHTML = CountdownTimer.addZero(minutes);
this.lastMinutes = minutes;
}
if (initialUpdate || this.lastHours !== hours) {
if (hoursBlock) hoursBlock.innerHTML = CountdownTimer.addZero(hours);
this.lastHours = hours;
}
if (initialUpdate || this.lastDays !== days) {
if (daysBlock) {
daysBlock.innerHTML = CountdownTimer.addZero(days);
}
this.lastDays = days;
}
if (days === 0 && daysBlock && !initialUpdate) {
daysBlock.parentElement.parentElement.remove();
}
_this.classList.remove("loading-effect");
}
}
static addZero(x) {
return x < 10 && x >= 0 ? "0" + x : x;
}
}
customElements.define("countdown-timer", CountdownTimer);
if (!customElements.get("text-truncator")) {
class TextTruncator extends HTMLElement {
constructor() {
super();
this.initElements();
}
connectedCallback() {
this.setupTextTruncation();
}
initElements() {
this.textTruncatorButton = this.querySelector(".text-truncator__button");
this.textTruncatorButtonText = this.textTruncatorButton?.querySelector(".text-truncator__button-text");
this.textTruncatorIconPlus = this.textTruncatorButton?.querySelector(".icon-plus");
this.textTruncatorIconMinus = this.textTruncatorButton?.querySelector(".icon-minus");
}
setupTextTruncation() {
const textTruncator = this.querySelector(".text-truncator");
textTruncator.style.display = "block"; 
const { lineHeight, lineCount, maxLineCount } = this.calculateLineCounts(textTruncator);
if (lineCount > maxLineCount) {
this.applyTextTruncation(textTruncator, lineHeight, maxLineCount);
this.setupButton(textTruncator);
} else {
this.removeTextTruncation(textTruncator);
}
}
calculateLineCounts(element) {
const lineHeight = parseFloat(window.getComputedStyle(element).lineHeight);
const lineCount = Math.floor(element.clientHeight / lineHeight);
const maxLineCount = parseInt(this.dataset.maxLineCount);
return { lineHeight, lineCount, maxLineCount };
}
applyTextTruncation(element, lineHeight, maxLineCount) {
element.classList.add("text-truncator--hidden");
const maxHeight = `${lineHeight * maxLineCount}px`;
const style = document.createElement("style");
style.innerHTML = `.text-truncator--hidden { max-height: ${maxHeight}; }`;
document.head.appendChild(style);
if (this.textTruncatorButton) {
this.textTruncatorButton.style.display = "";
}
}
removeTextTruncation(element) {
element.classList.remove("text-truncator--hidden");
if (this.textTruncatorButton) {
this.textTruncatorButton.style.display = "none";
}
}
setupButton(textTruncator) {
if (this.textTruncatorButton) {
this.textTruncatorButtonText.innerHTML = `<span>${this.dataset.readMore}</span>`;
this.toggleIcons("plus");
this.textTruncatorButton.addEventListener("click", (event) => {
event.preventDefault();
this.toggleTextTruncation(textTruncator);
});
}
}
toggleTextTruncation(textTruncator) {
const paragraphs = textTruncator.querySelectorAll("p");
const isHidden = textTruncator.classList.contains("text-truncator--hidden");
paragraphs.forEach((paragraph, index) => {
paragraph.style.marginTop = isHidden && index !== 0 ? "1rem" : "";
});
textTruncator.classList.toggle("text-truncator--hidden");
this.textTruncatorButtonText.innerHTML = `<span>${isHidden ? this.dataset.readLess : this.dataset.readMore}</span>`;
this.toggleIcons(isHidden ? "minus" : "plus");
if (isHidden && DeviceDetector.isMobile()) {
textTruncator.style.overflow = "scroll";
} else {
textTruncator.style.maxHeight = "";
textTruncator.style.overflow = "";
}
}
toggleIcons(iconType) {
this.textTruncatorIconPlus.style.display = iconType === "plus" ? "inline-block" : "none";
this.textTruncatorIconMinus.style.display = iconType === "minus" ? "inline-block" : "none";
}
}
customElements.define("text-truncator", TextTruncator);
}
class BackToTop extends HTMLElement {
constructor() {
super();
this.vertical_offset_for_trigger = window.innerHeight * 0.5;
this.addEventListener("click", this.scrollToTop.bind(this));
}
scrollToTop() {
window.scroll({
top: 0,
behavior: "smooth"
});
}
connectedCallback() {
window.addEventListener("scroll", () => this.handleScroll(), {
passive: true
});
}
handleScroll() {
const top = window.pageYOffset;
if (top > this.vertical_offset_for_trigger) {
this.classList.remove("hide");
} else {
this.classList.add("hide");
}
}
}
customElements.define("back-to-top", BackToTop);
const submenuButtons = document.querySelectorAll(
".drawer__submenu-btn"
);
submenuButtons.forEach(button => {
button.addEventListener("click", function () {
const parentDiv = button.parentElement;
const isActive = parentDiv.classList.contains("is-active");
const submenuSecond = parentDiv.querySelector(
".drawer__submenu-second"
);
if (submenuSecond) {
submenuSecond.style.height = isActive ? "0px" : "auto";
}
const submenuItems = document.querySelectorAll(
".drawer__submenu-first-item"
);
submenuItems.forEach(item => {
item.classList.remove("is-active");
const submenu = item.querySelector(".drawer__submenu-second");
if (submenu) {
submenu.style.height = "0px";
}
});
if (!isActive) {
parentDiv.classList.add("is-active");
const submenuSec = parentDiv.querySelector(
".drawer__submenu-second"
);
if (submenuSec) {
submenuSec.style.height = "auto";
}
}
});
});
const PUB_SUB_EVENTS = {
cartUpdate: "cart-update",
quantityUpdate: "quantity-update",
variantChange: "variant-change",
cartError: "cart-error"
};
document.addEventListener("DOMContentLoaded", function () {
var menuLinks = document.querySelectorAll("button.menu-link");
menuLinks.forEach(function (menuLink) {
menuLink.addEventListener("click", function () {
var activeMenuLink = document.querySelector(".menu-panel.is-active");
var isNested = activeMenuLink?.hasAttribute("data-menu-nested");
var targetRef = menuLink.dataset.ref;
var targetPanel = document.querySelector(
'div.menu-panel[data-menu="' + targetRef + '"]'
);
var allPanels = document.querySelectorAll(".menu-panel");
const primaryMenuPanel = document.querySelector(".primary-menu-panel");
let hasActive = false;
if (targetPanel) {
allPanels.forEach(function (panel) {
if (panel.classList.contains("is-active")) {
hasActive = true;
if (panel.hasAttribute("data-menu-nested")) {
panel.classList.add("was-active");
primaryMenuPanel.style.opacity = "0";
panel.classList.remove("is-active");
} else {
setTimeout(() => {
panel.style.opacity = "0";
}, 300);
setTimeout(() => {
panel.classList.remove("is-active");
}, 500);
}
if (panel.classList.contains("is-back")) {
panel.classList.remove("is-back");
}
primaryMenuPanel.style.opacity = "0";
}
});
if (hasActive) {
primaryMenuPanel.style.opacity = "0";
} else {
primaryMenuPanel.style.opacity = "1";
}
targetPanel.classList.add("is-active");
targetPanel.style.opacity = "1";
if (targetPanel.classList.contains("is-back")) {
targetPanel.classList.remove("is-back");
}
if (isNested) {
targetPanel.classList.add("is-instant");
}
setTimeout(() => {
allPanels.forEach(function (panel) {
if (panel.classList.contains("was-active")) {
panel.classList.remove("was-active");
}
targetPanel.classList.remove("is-instant");
});
}, 300);
} else {
primaryMenuPanel.style.opacity = "1";
allPanels.forEach(function (panel) {
if (panel.classList.contains("is-active")) {
panel.classList.remove("is-active");
panel.classList.add("is-back");
panel.classList.add("non-active");
setTimeout(() => {
panel.classList.remove("non-active");
}, 300);
}
})
}
});
});
var faqPage = document.querySelector('.template--faq');
if(faqPage) {
var accordions = document.querySelectorAll(".accordion__section");
accordions.forEach(function (accordion) {
accordion.addEventListener("click", function () {
var headerHeight = document.querySelector(".header").offsetHeight;
var bodyHeight = this.offsetHeight;
var accordionTop = accordion.getBoundingClientRect().top;
var scrollTo = accordionTop - headerHeight - bodyHeight;
if (scrollTo < 0) {
scrollTo = 0;
}
if (accordionTop > headerHeight) {
scrollTo = window.scrollY;
}
window.scrollTo({
top: scrollTo,
behavior: "smooth"
});
});
});
}
});